/**
 * Constants for Kaart van Mensenkennis
 */

// Dembrane brand colors
export const COLORS = {
  // Primary
  parchment: '#f6f4f1',
  graphite: '#2d2d2c',
  royalBlue: '#4169e1',

  // Accents
  cyan: '#00ffff',
  springGreen: '#1effa1',
  mauve: '#ffc2ff',
  lime: '#f4ff81',
} as const;

// Offering category colors for map markers
export const CATEGORY_COLORS = {
  core: COLORS.cyan,
  'part-of': COLORS.springGreen,
  training: COLORS.mauve,
} as const;

// Dutch provinces
export const PROVINCES = [
  'Drenthe',
  'Flevoland',
  'Friesland',
  'Gelderland',
  'Groningen',
  'Limburg',
  'Noord-Brabant',
  'Noord-Holland',
  'Overijssel',
  'Utrecht',
  'Zeeland',
  'Zuid-Holland',
] as const;

// Sector options
export const SECTORS = [
  { value: 'public', label: 'Publiek' },
  { value: 'private', label: 'Privaat' },
  { value: 'both', label: 'Beide' },
] as const;

// Service tags (predefined list - will be populated from Notion at build time)
export const SERVICE_TAGS = [
  'burgerberaad',
  'burgerparticipatie',
  'dialoog facilitatie',
  'deep democracy',
  'liberating structures',
  'world cafe',
  'open space',
  'art of hosting',
  'facilitatie training',
  'omgevingswet participatie',
] as const;

// Ticker announcement types
export const TICKER_TYPES = [
  { value: 'vacancy', label: 'Vacature' },
  { value: 'open_call', label: 'Open call' },
  { value: 'subsidy', label: 'Subsidie' },
  { value: 'other', label: 'Anders' },
] as const;

// Map configuration
export const MAP_CONFIG = {
  // Initial view bounds for Netherlands
  bounds: {
    minLat: 50.75,
    maxLat: 53.55,
    minLng: 3.35,
    maxLng: 7.25,
  },
  // Marker sizes
  markerRadius: {
    default: 10,
    noLogo: 7,
    dembranePartner: 12,
  },
  // Force simulation parameters
  forceSimulation: {
    collisionRadius: 14,
    collisionStrength: 0.7,
  },
} as const;

// API endpoints (for serverless functions)
export const API_ENDPOINTS = {
  submit: '/api/submit',
  claim: '/api/claim',
  feedback: '/api/feedback',
} as const;

// External links
export const EXTERNAL_LINKS = {
  dembrane: 'https://dembrane.com',
} as const;
